module.exports = __webpack_public_path__ + "img/volyn_energo.0fe452c3.png";